import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { colors } from '../../lib/colors';

interface Props {
  data: Record<string, any>[];
  xKey: string;
  stackKeys: string[];
  height?: number;
}

// Amber-based palette derived from the LAOSS accent.
const PALETTE = ['#EF9F27', '#FAB055', '#FCC683', '#FDDCAE', '#FEEAD0', '#FFF5E8'];

export function StackedBarChart({ data, xKey, stackKeys, height = 320 }: Props) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
        <CartesianGrid stroke={colors.borderLight} vertical={false} />
        <XAxis dataKey={xKey} stroke={colors.textMuted} fontSize={11} tickLine={false} axisLine={{ stroke: colors.border }} />
        <YAxis stroke={colors.textMuted} fontSize={11} tickLine={false} axisLine={{ stroke: colors.border }} />
        <Tooltip
          contentStyle={{ background: colors.surface, border: `0.5px solid ${colors.border}`, borderRadius: 8, fontSize: 12 }}
          cursor={{ fill: colors.accentMuted, opacity: 0.4 }}
        />
        <Legend wrapperStyle={{ fontSize: 11, color: colors.textSecondary }} />
        {stackKeys.map((k, i) => (
          <Bar key={k} dataKey={k} stackId="a" fill={PALETTE[i % PALETTE.length]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
